import { render, staticRenderFns } from "./getBonafideCertificateVvp.vue?vue&type=template&id=2bd7c866&scoped=true&"
import script from "./getBonafideCertificateVvp.vue?vue&type=script&lang=js&"
export * from "./getBonafideCertificateVvp.vue?vue&type=script&lang=js&"
import style0 from "./getBonafideCertificateVvp.vue?vue&type=style&index=0&id=2bd7c866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd7c866",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VRow,VTextField})
